const REACT_APP_AGORA_APP_ID = '9721bfd134334e5a9114ee654e7d1389';
export default REACT_APP_AGORA_APP_ID;
